import { render, staticRenderFns } from "./TheoryPracticeWorkshopPayment.vue?vue&type=template&id=b22e88c4&scoped=true&"
import script from "./TheoryPracticeWorkshopPayment.vue?vue&type=script&lang=js&"
export * from "./TheoryPracticeWorkshopPayment.vue?vue&type=script&lang=js&"
import style0 from "./TheoryPracticeWorkshopPayment.vue?vue&type=style&index=0&id=b22e88c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b22e88c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCheckbox,VCol,VContainer,VForm,VRow})
